import { supabase } from '../lib/supabaseClient';
import { backgroundSyncService } from './backgroundSyncService';

interface ErrorReport {
  error_message: string;
  error_stack?: string;
  user_id?: string;
  page_url: string;
  user_agent: string;
  timestamp: string;
  severity: 'low' | 'medium' | 'high' | 'critical';
  context?: any;
}

class ErrorReportingService {
  private isEnabled = true;

  async reportError(error: Error, context?: any, severity: 'low' | 'medium' | 'high' | 'critical' = 'medium') {
    if (!this.isEnabled) return;

    const errorReport: ErrorReport = {
      error_message: error.message,
      error_stack: error.stack,
      page_url: window.location.href,
      user_agent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      severity,
      context: context ? JSON.stringify(context) : null
    };

    // Mevcut background sync kullan
    backgroundSyncService.addTask('analytics', { 
      table: 'error_reports',
      data: errorReport 
    }, severity === 'critical' ? 'high' : 'medium');

    // Critical hatalar için anında gönder
    if (severity === 'critical') {
      try {
        await supabase.from('error_reports').insert(errorReport);
      } catch (e) {
        console.error('Critical error reporting failed:', e);
      }
    }
  }

  // Mevcut GlobalErrorBoundary ile entegre
  setupGlobalHandlers() {
    window.addEventListener('error', (event) => {
      this.reportError(new Error(event.message), {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno
      }, 'high');
    });

    window.addEventListener('unhandledrejection', (event) => {
      this.reportError(new Error(event.reason), {
        type: 'unhandled_promise_rejection'
      }, 'high');
    });
  }

  disable() { this.isEnabled = false; }
  enable() { this.isEnabled = true; }
}

export const errorReportingService = new ErrorReportingService();
